// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


// @ts-ignore
import { OpticalOrderPodOrderResponse } from './optical-order-pod-order-response';

/** See com.rev360.pms.api.controller.patient.opticalsummary.OpticalOrderPodContactLensResponse */
/* istanbul ignore next */
@GandalfModel
export class OpticalOrderPodContactLensResponse extends OpticalOrderPodOrderResponse {

	@GandalfProperty({ designType: String })
	comments!: string | null;

	@GandalfProperty({ propertyType: 'LocalDate', designType: Date })
	createdOn!: Date | null;

	@GandalfProperty({ designType: String })
	instructions!: string | null;

	@GandalfConstantDecorator(constants.ContactLensPrescriptionType)
	@GandalfProperty({ designType: constants.ContactLensPrescriptionType })
	lensType!: constants.ContactLensPrescriptionType | null;

	@GandalfProperty({ designType: String })
	odColor!: string | null;

	@GandalfProperty({ designType: String })
	odModel!: string | null;

	@GandalfProperty({ designType: String })
	odPackagingType!: string | null;

	@GandalfProperty({ designType: Number })
	odQuantity!: number | null;

	@GandalfProperty({ designType: Boolean })
	onHold!: boolean | null;

	@GandalfProperty({ designType: Number })
	orderId!: number | null;

	@GandalfConstantDecorator(constants.OrderType)
	@GandalfProperty({ designType: constants.OrderType })
	orderType!: constants.OrderType | null;

	@GandalfProperty({ designType: String })
	osColor!: string | null;

	@GandalfProperty({ designType: String })
	osModel!: string | null;

	@GandalfProperty({ designType: String })
	osPackagingType!: string | null;

	@GandalfProperty({ designType: Number })
	osQuantity!: number | null;

	@GandalfConstantDecorator(constants.OrderStatusCode)
	@GandalfProperty({ designType: constants.OrderStatusCode })
	status!: constants.OrderStatusCode | null;

	@GandalfProperty({ propertyType: 'LocalDate', designType: Date })
	statusDate!: Date | null;

}
